module.exports = __webpack_public_path__ + "static/img/23.6f6a5361.png";